/**
 * TanStack Query client configuration for admin dashboard.
 *
 * Configured with:
 * - staleTime: 30s for admin data freshness (AR10)
 * - gcTime: 10 min garbage collection
 * - retry: 1 attempt on failure
 * - refetchOnWindowFocus: true for dashboard freshness
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30 seconds for admin data
      gcTime: 600_000, // 10 minutes garbage collection
      retry: 1,
      refetchOnWindowFocus: true, // Important for admin dashboard freshness
    },
  },
});

// Expose queryClient on window so E2E tests can programmatically
// invalidate the cache instead of waiting for staleTime. This is safe
// in all environments — it only provides cache control, no sensitive data.
(window as unknown as Record<string, unknown>).__GBTY_QUERY_CLIENT__ =
  queryClient;
